<template>
  <div>
    <div class="hero is-bold">
      <div class="hero-body" style="padding-left: 0px">
        <div class="level" style="width:100%">
          <div class="level-left">
            <v-btn icon @click="isSpecialOffer ? $router.replace({ name: 'SpecialOffers' }) : $router.replace({ name: 'Menus' }) ">
              <v-icon large>keyboard_arrow_left</v-icon>
            </v-btn>
            <h1 class="title">{{isSpecialOffer ? specialOfferMenu.name : menu.name}}</h1>
          </div>
          <div class="level-right">
            <div class="level-item">
              <b-button v-if="isSpecialOffer" icon-left="edit" class="button is-info level-item" @click="editMenu($route.params.id, true)">Edit</b-button>
              <b-button v-else icon-left="edit" class="button is-info level-item" @click="editMenu($route.params.id, false)">Edit</b-button>
            </div>
            <div class="level-item">
              <b-button icon-left="trash" class="button is-danger level-item" @click="confirmRemove">Remove</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-carousel :autoplay="false" indicator-inside v-if="!isSpecialOffer">
      <b-carousel-item v-for="(item, id) of menu.items" :key="id">
        <div class="image" style="height:400px; background-color:black">
          <img :src="getImageUrl(id, false)" style="height:100%; width:auto; margin: 0 auto">
        </div>
      </b-carousel-item>
    </b-carousel>
    <b-carousel :autoplay="false" indicator-inside v-else>
      <b-carousel-item v-for="(item, id) of specialOfferMenu.items" :key="id">
        <div class="image" style="height:400px; background-color:black">
          <img :src="getImageUrl(id, true)" style="height:100%; width:auto; margin: 0 auto">
        </div>
      </b-carousel-item>
    </b-carousel>
  </div>
</template>

<script>
import MenuAddEdit from '@/components/menu/MenuAddEdit'

export default {
  name: 'MenuDetails',
  props: ['isSpecialOffer'],
  /* mounted: function () {
    let id = this.$route.params.id
    if (this.isSpecialOffer) {
      this.staticMenuRef = Object.assign({}, this.$store.getters.getSpecialOffer(id))
    }
    this.items = [...this.staticMenuRef.items.filter(x => x)]
  }, */
  computed: {
    menu () {
      let id = this.$route.params.id
      return this.$store.getters.getMenu(id)
    },
    specialOfferMenu () {
      let id = this.$route.params.id
      return this.$store.getters.getSpecialOffer(id)
    },
    workspaceId () {
      return this.$store.state.workspaceId
    },
    userId () {
      return this.$store.state.uid
    }
  },
  methods: {
    confirmRemove () {
      this.$buefy.dialog.confirm({
        title: 'Delete menu',
        message: 'Are you sure you want to <b>delete</b> this menu? This action cannot be undone.',
        confirmText: 'Delete',
        type: 'is-danger',
        onConfirm: () => this.removeMenu()
      })
    },
    editMenu (id, isSpecial) {
      this.bAddMenu = true
      this.$buefy.modal.open({
        parent: this,
        component: MenuAddEdit,
        props: { editEnabled: true, propId: id, propParentFn: this.cancelAdd, isSpecialOffer: isSpecial },
        hasModalCard: true,
        trapFocus: true
      })
    },
    removeMenu (isSpecial) {
      let id = this.$route.params.id
      let associatedClustersRef = this.$store.getters.getClustersForMenu(id)
      for (let cluster in associatedClustersRef) {
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.database.ref('/neoslide/clusters/' + this.workspaceId + '/' + cluster).update({
            menuId: ''
          })
        } else {
          this.$store.state.database.ref('/clusters/' + this.userId + '/' + cluster).update({
            menuId: ''
          })
        }
      }
      let removeMenuRef = null
      if (isSpecial) {
        if (!this.getNotMigrated().includes(this.userId)) {
          removeMenuRef = this.$store.state.database.ref('/neoslide/specialOfferMenu/' + this.workspaceId + '/' + id)
        } else {
          removeMenuRef = this.$store.state.database.ref('/specialOfferMenu/' + this.userId + '/' + id)
        }
        removeMenuRef.remove()
        let removeMenuFilesRef = null
        if (!this.getNotMigrated().includes(this.userId)) {
          this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffers/' + id)
        } else {
          this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffers/' + id)
        }
        removeMenuFilesRef.listAll().then(dir => {
          dir.items.forEach(fileRef => {
            fileRef.delete().then(() => {
              this.globalLogger('deleted file' + fileRef.name)
            })
          })
        })
        this.$router.push({ name: 'SpecialOffers' })
      } else {
        if (!this.getNotMigrated().includes(this.userId)) {
          removeMenuRef = this.$store.state.database.ref('/neoslide/menu/' + this.workspaceId + '/' + id)
        } else {
          removeMenuRef = this.$store.state.database.ref('/menu/' + this.userId + '/' + id)
        }
        removeMenuRef.remove()
        let removeMenuFilesRef = null
        if (!this.getNotMigrated().includes(this.userId)) {
          removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/Menus/' + id)
        } else {
          removeMenuFilesRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/Menus/' + id)
        }
        removeMenuFilesRef.listAll().then(dir => {
          dir.items.forEach(fileRef => {
            fileRef.delete().then(() => {
              this.globalLogger('deleted file' + fileRef.name)
            })
          })
        })
        this.$router.push({ name: 'Menus' })
      }
    },
    cancelAdd () {
      this.bAddMenu = false
    },
    logItems () {
      this.globalLogger(this.menu.items)
    },
    getImageUrl (id, isSpecial) {
      if (isSpecial) {
        return this.specialOfferMenu.items[id].imageUrl
      } else {
        return this.menu.items[id].imageUrl
      }
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/menu/MenuDetails.vue